<style>
@import '../../assets/css/report.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <form @submit.prevent="initialize" :submit="initialize">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_created_at')}}</template>
                            <el-input type="date" v-model="ajaxSearch.created_at" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <el-input v-model="ajaxSearch.master_id" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                        </b-form-group>
                    </form>
                </b-card>
                <b-card :header="$t($route.name)">
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import {validDownlineAjaxTable} from '@/system/model/report'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',master_id:'',daily_wallet_amount:'',valid_downline:'',self_valid:''},
            ajaxRow:'',
            pageLimit:10,
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'50'
            },{
                prop: "created_at",
                label: this.$t('admin.table_created_at'),
                width:'170'
            },{
                prop: "master_id",
                label: this.$t('admin.table_username'),
                width:'150'
            },{
                prop: "daily_wallet_amount",
                label: this.$t('admin.table_daily_wallet_amount'),
                width:'170 '                
            },{
                prop: "valid_downline",
                label: this.$t('admin.table_valid_downline'),
                width:'170'                              
            },{
                prop: "self_valid",
                label: this.$t('admin.table_self_valid'),
                width:'170'                              
            }]        
        }
    },methods:{
       initialize(){
            var self = this;
            var result = validDownlineAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.master_id,this.ajaxSearch.daily_wallet_amount,this.ajaxSearch.valid_downline,this.ajaxSearch.self_valid);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
